let slickDefaults = require('../slick-default/slick-default');
require('./brands-slider.less');

let size = require('../../modules/size');

jQuery(function() {
    $('.js-slick-brands').each(function() {
        var $brandsSlider = $(this);

        $brandsSlider.slick(
            $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
                slidesToShow: 5,
                responsive: [
                    {
                        breakpoint: size.desktop,
                        settings: { slidesToShow: 4 }
                    },
                    {
                        breakpoint: size.tabletBig,
                        settings: { slidesToShow: 3 }
                    },
                    {
                        breakpoint: size.tablet,
                        settings: { slidesToShow: 2 }
                    },
                    {
                        breakpoint: size.mobileBig,
                        settings: { slidesToShow: 1 }
                    }
                ]
            })
        );
    });
});



// WEBPACK FOOTER //
// ./blocks/brands-slider/brands-slider.js